// extracted by mini-css-extract-plugin
module.exports = {"dont-know-man-icon":"dd31006766--dont-know-man-icon--gH7rL"};